import React from 'react';
import Phone, { isValidPhoneNumber } from 'react-phone-number-input/max';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Translate, I18n } from 'react-redux-i18n';

import 'react-phone-number-input/style.css';

const isValidPhone = phone => isValidPhoneNumber(phone);

class PhoneInput extends React.Component {
  constructor(...props) {
    super(...props);

    this.handlePhone = this.handlePhone.bind(this);

    let phone = !!this.props.phone
      ? parsePhoneNumberFromString(this.props.phone, 'RU')
      : '';
    phone = phone && phone.number ? phone.number : phone;

    this.state = {
      phoneValid: isValidPhone(phone),
      phone: phone,
      highlight: false,
    };
  }

  componentDidMount() {
    this.handlePhone(this.state.phone);
  }

  handlePhone(value) {
    const phone = !!value ? value : '';
    this.setState(
      {
        phone: phone,
        phoneValid: isValidPhone(phone),
      },
      () => {
        this.props.callback(this.state.phone, this.state.phoneValid);
      }
    );
  }

  render() {
    const { phone, phoneValid } = this.state;
    const { highlight, hideLabel } = this.props;

    let phoneMessage = '';
    if (phone || highlight) {
      if (!phoneValid) {
        phoneMessage = <Translate value="register.errors.phone.incorrect" />;
      }
    }

    return (
      <div className="phone-input">
        {!hideLabel && (
          <p className="text" style={{ marginBottom: '1em' }}>
            {I18n.t('other.contactPhoneNumber')}
          </p>
        )}
        <Phone
          defaultCountry="RU"
          placeholder={I18n.t('other.yourNumber')}
          value={phone}
          onChange={this.handlePhone}
        />
        <span className="help-block">{phoneMessage}</span>
      </div>
    );
  }
}

export default PhoneInput;
